import React from "react";
import "../styles/ScrapCar.css";

export default function ScrapCar() {
  return (
    <div className="page-container">
      <h1 className="page-title">Scrap Your Car</h1>
      <p className="subtitle">Safe. Legal. Hassle-free.</p>

      {/* 🔥 Coming Soon */}
      <h2 style={{ color: "#003566" }}>🚧 Coming Soon</h2>

      <p style={{ color: "#666" }}>
        This feature will be available soon. Stay tuned!
      </p>
    </div>
  );
}